import { render } from "./SubscribeAction.vue?vue&type=template&id=6e5a0556&scoped=true"
import script from "./SubscribeAction.vue?vue&type=script&lang=ts"
export * from "./SubscribeAction.vue?vue&type=script&lang=ts"

import "./SubscribeAction.vue?vue&type=style&index=0&id=6e5a0556&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6e5a0556"

export default script